import { render, staticRenderFns } from "./folders-payments-detail.vue?vue&type=template&id=f614cc56&scoped=true"
import script from "./folders-payments-detail.vue?vue&type=script&lang=js"
export * from "./folders-payments-detail.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "f614cc56",
  null
  
)

export default component.exports